// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__X7o9M","Cards-wrapper":"Cards_Cards-wrapper__p07zw","card":"Cards_card__TQ+Dj","icon-wrapper":"Cards_icon-wrapper__KVrE6"};